import React from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { Input } from "@revvsales/components";
import { RevvForm, CustomSelect } from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";
import { US_STATES_OPTIONS } from "../../../../constants/customDynamicMeta";
// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
  setFlagForCommonFields,
} = DocumentTemplateActions;

class UsstateField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDefaultValue: this._getShowDefaultValue(props),
      usstatesFieldValues: this._getDataForPrepopulate(props),
    };
  }

  _getShowDefaultValue = propsData => {
    let returnData = false;
    if (propsData.meta && propsData.meta.default) {
      returnData = true;
    }
    return returnData;
  };

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.US_STATES),
    );
    if (
      propsData.meta &&
      propsData.meta.options &&
      propsData.meta.options.length > 0
    ) {
      returnData = {
        options: this._prepareOptions(propsData.meta.options),
        default: this._prepareOptionsForUsStates(propsData.meta.default),
      };
    }
    return returnData;
  };

  _prepareOptionsForUsStates = data => {
    let returnData = "";
    if (data) {
      returnData = { name: data, id: data };
    }
    return returnData;
  };

  _prepareOptions = data => {
    const returnData = [];
    if (data && data.length > 0) {
      data.forEach(element => {
        returnData.push({ name: element, id: element });
      });
    }
    return returnData;
  };

  _toggleDefaultValue = () => {
    const { showDefaultValue } = this.state;
    this.setState({ showDefaultValue: !showDefaultValue });
  };

  resetState = () => {
    this.props.setFlagForDefault(true);
    this.props.metaValidStatus(false);
    const { showDefaultValue } = this.state;
    if (showDefaultValue === true) {
      this.setState({ showDefaultValue: false });
    }
  };

  render() {
    const { showDefaultValue, usstatesFieldValues } = this.state;
    console.debug("Common field values");
    console.debug(usstatesFieldValues);
    return (
      <React.Fragment>
        <RevvForm
          initialFormValue={usstatesFieldValues}
          customFieldName="US_STATES"
          customFieldComponentRules={CustomFieldComponentRules}
          customFieldComponentMessages={CustomFieldComponentMessages}
          validateOnChange={false}
          render={formProps => {
            const {
              handleChangeByName,
              messages,
              touched,
              errors,
              values,
              isValid,
            } = formProps;
            const allInAll = {
              isValid,
              messages,
              touched,
              errors,
              values,
            };
            console.debug("allInAllhhh", allInAll);
            if (!showDefaultValue && values.default !== undefined) {
              values.default = undefined;
            }
            if (values.options.length === 0) {
              this.resetState();
            }
            const options = [];
            for (let d = 0; d < values.options.length; d += 1) {
              options.push(values.options[d].name);
            }
            const data = {
              default: values.default !== undefined ? values.default.name : "",
              options,
            };
            if (
              data.options.length > 0 &&
              !showDefaultValue &&
              data.default === ""
            ) {
              this.props.setFlagForDefault(false);
            } else if (
              data.options.length > 0 &&
              showDefaultValue &&
              data.default === ""
            ) {
              this.props.setFlagForDefault(true);
              this.props.metaValidStatus(false);
            } else if (
              data.options.length > 0 &&
              showDefaultValue &&
              data.default !== ""
            ) {
              this.props.setFlagForDefault(true);
              this.props.metaValidStatus(true);
            }
            this.props.setMetaFieldValues(data);

            return (
              <React.Fragment>
                <span className="revvform-label">
                  US states
                  <span className="requiredwitherr-input">*</span>
                </span>
                <CustomSelect
                  id="options"
                  name="options"
                  value={values.options}
                  getOptionLabel={({ name }) => name}
                  options={US_STATES_OPTIONS}
                  isMulti
                  _handleChangeInSelect={value =>
                    handleChangeByName(value, "options")
                  }
                  required
                />
                {values.options.length > 0 && (
                  <React.Fragment>
                    <div className="dynamicfieldcustom-default-container">
                      <Input
                        id="checkbox"
                        type="checkbox"
                        data-test="CountryField-checkbox"
                        checked={showDefaultValue}
                        onChange={() => this._toggleDefaultValue()}
                        className="dynamicfieldcustom-footer-input errorborder"
                      />
                      <span className="dynamicfieldcustom-footer-checkboxinput">
                        This has a default value
                      </span>
                    </div>
                  </React.Fragment>
                )}

                {showDefaultValue && values.options.length > 0 && (
                  <div>
                    <span className="revvform-label">
                      Default value
                      <span className="requiredwitherr-input"> *</span>
                    </span>
                    <CustomSelect
                      autoFocus
                      id="default"
                      name="default"
                      value={values.default}
                      getOptionLabel={({ name }) => name}
                      options={values.options}
                      _handleChangeInSelect={value =>
                        handleChangeByName(value, "default")
                      }
                      required
                    />
                  </div>
                )}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
  setFlagForCommonFields,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UsstateField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/UsstatesField.js